<template>
  <b-container id="app2" class="bv-example-row" fluid="true xl md sm xs">
    <b-row>
      <b-col md="8">
        <div style="text-align: left; padding: 0.5rem 2rem">
          課程名稱過濾：
          <b-form-select
            class="form-control"
            id="cidSelectText2"
            v-model="selected2"
            value-field="CID"
            text-field="CourseName"
            ref="selected2"
            @change="UpdateCourseNameCID()"
            :options="options2"
          >
          </b-form-select>


          <br />

          目前共 {{ total }}筆
        </div>
        <div
          v-if="PaymentManageShow"
          id="PaymentManage"
          class="well"
          style="padding: 0 1em"
        >
          <b-tabs content-class="mt-3" justified>
            <div
              class="dataTables_scrollBody"
              style="
                font-size: 14px;
                position: relative;
                overflow: auto;
                max-height: 100%;

                border-bottom: 1px solid #111;
                border-top: 1px solid #111;
              "
            >
              <b-table-simple
                class="ncut-table-menu-striped ncut-table-menu"
                fixed
                responsive
                bgcolor="#FFFFFF"
              >
                <b-thead class="ncut-thead-menu">
                  <b-tr>
                    <b-th style="min-width: 1em"></b-th>
                    <b-th colspan="2" style="min-width: 20em">轉帳帳號</b-th>
                    <b-th style="min-width: 3em">姓名</b-th>
                    <b-th style="min-width: 5em">身分證字號</b-th>
                    <b-th style="min-width: 2em">聯絡電話</b-th>
                    <b-th style="min-width: 2em">是否繳費</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody class="ncut-tbody-menu">
                  <b-tr
                    v-for="(item, index) in filteredDocs"
                    :key="index"

                    v-bind:style="{
                      background: selectedRowIndex == index ? headerColor : '',
                    }"
                    @click="selectedRowIndex = index"
                  >
                    <b-td style="text-align: right">

                      <a class="frame_title1" href="#" @click="ShowPay(index)"><i class="fas fa-search"></i></a>

                    </b-td>
                    <b-td colspan="2" style="text-align: left">{{ item.account }}</b-td>
                    <b-td style="text-align: left">{{ item.name }}</b-td>
                    <b-td style="text-align: left">{{ item.idNo }}</b-td>
                    <b-td style="text-align: left">{{ item.phoneNo1 }}</b-td>
                    <b-td style="text-align: left">{{
                      isPayment_txt[item.isPayment].txt
                    }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="pageSize"
                v-if="total > pageSize"
              />
            </div>
          </b-tabs>
        </div>
      </b-col>
      <b-col md="4">
        <div
          v-if="PaymentEditShow"

          class="well"
          style="padding: 0 1em"
        >



              <b-table-simple
                class="ncut-table-menu-striped ncut-table-menu"
                fixed
                responsive
                bgcolor="#FFFFFF"
              >
                <b-tbody class="ncut-tbody-menu">
                  <b-tr>
                    <b-td style="text-align: left"> 姓名: </b-td>
                    <b-td style="text-align: left">
                      {{ inputData[editId].name }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td style="text-align: left"> 電話: </b-td>
                    <b-td style="text-align: left">
                      {{ inputData[editId].phoneNo1 }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td style="text-align: left"> E-Mail: </b-td>
                    <b-td style="text-align: left">
                      {{ inputData[editId].eMail }}
                    </b-td>
                  </b-tr>

                  <b-tr>
                    <b-td style="text-align: left"> 交易類別: </b-td>
                    <b-td style="text-align: left"> 銀行 </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td style="text-align: left"> 繳款日期: </b-td>
                    <b-td style="text-align: left">
                      {{ inputData[editId].payUpdateTime }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td style="text-align: left"> 金額: </b-td>
                    <b-td style="text-align: left">
                      {{ inputData[editId].amount }}
                    </b-td>
                  </b-tr>
                   <b-tr>
                    <b-td style="text-align: left"> 繳款狀況: </b-td>
                    <b-td style="text-align: left">
                      <b-form-radio-group
      v-model="selected3"
      :options="options3"
      class="mb-3"
      value-field="item"
      text-field="name"
      disabled-field="notEnabled"
    ></b-form-radio-group>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>

            </div>


      </b-col>
    </b-row>
  </b-container>
</template>


<script>

import * as tools from "../tool";
export default {
  name: "PaymentManage",
  data() {
    return {
      payUpdateTime:null,
      isPayment_txt: [
        { 0: 0, txt: "否" },
        { 1: 1, txt: "銀行繳費" },
        { 2: 2, txt: "現場繳費" },
      ],

      PaymentManageShow: true,
      PaymentEditShow: false,
      cid: null,
      signUpID: null,
      selected2: null,
      options2: null,
      selected3: null,
        options3: [
          { item: '0', name: '尚未繳費' , notEnabled: true},
          { item: '1', name: '銀行' , notEnabled: true},
          { item: '2', name: '現場繳費', notEnabled: true },
        ],
      editId: 0,
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },

  methods: {
    ShowPay(index){
      let vm = this;
      vm.editId=index;
      vm.PaymentEditShow=true;
      vm.selected3=vm.inputData[index].isPayment;

       },
    UpdatePaySignUp() {
      let vm = this;

      this.$http
        .get("./WebApi/ociaRep/UpdatePaySignUp/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
      getPaySignUp(cid) {
      let vm = this;

      this.$http
        .get("./WebApi/ociaRep/getPaySignUp/".concat(cid))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },

    UpdateCourseNameCID() {
      let obj = document.getElementById("cidSelectText2");
      this.cid = this.options2[obj.selectedIndex].CID;
      this.getPaySignUp(this.cid);

    },
    GetCourseName() {
      var vm = this;
      this.$http
        .get("./WebApi/ociaRep/GetCourseName/")
        .then((response) => {
          if (response.data) {
            vm.inputData = response.data;
            vm.options2 = JSON.parse(vm.inputData);
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created CourseManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.GetCourseName();
    vm.UpdatePaySignUp();


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
